(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dellumia-mobile-circle-categories"] && !Shopify.designMode) return;
  try {
    

  (function () {

    if (!('customElements' in window) || customElements.get('dellumia-circle-nav-v4')) return;



    class DellumiaCircleNav extends HTMLElement {

      connectedCallback() {

        // Parser-safe: upgrade can precede completion of this element's child markup.

        if (this._initialized || this._initRaf) return;

        this._initRaf = window.requestAnimationFrame(() => {

          this._initRaf = 0;

          if (this.isConnected) this._initialize();

        });

      }



      _initialize() {

        if (this._initialized || !this.isConnected) return;

        this.scroller = this.querySelector('.dmc__scroller');

        this.list = this.querySelector('.dmc__list');

        this.track = this.querySelector('.dmc__progress');

        this.thumb = this.querySelector('.dmc__progress-thumb');

        if (!this.scroller || !this.list || !this.track || !this.thumb) {

          // A fragment or Theme Editor may append child nodes in a later task/frame.

          if (!this._childrenObserver && 'MutationObserver' in window) {

            this._childrenObserver = new MutationObserver(() => this._initialize());

            this._childrenObserver.observe(this, { childList: true, subtree: true });

          }

          return;

        }

        if (this._childrenObserver) {

          this._childrenObserver.disconnect();

          this._childrenObserver = null;

        }

        this._initialized = true;



        this.hideDelay = Number(this.dataset.hideDelay) || 2000;

        this._raf = 0;

        this._hideTimer = null;

        this._pendingSize = false;

        this._pendingReveal = false;

        this._usingWindowResize = false;



        // Resize-only geometry calculation: never perform card sizing on each scroll.

        this._updateSize = () => {

          if (this.dataset.widthMode !== 'visible') {

            if (this.style.getPropertyValue('--dmc-card-width')) {

              this.style.removeProperty('--dmc-card-width');

            }

            return;

          }



          const scrollerWidth = this.scroller.clientWidth;

          if (!scrollerWidth) return;

          const css = getComputedStyle(this);

          const visible = Math.max(1, parseFloat(css.getPropertyValue('--dmc-visible')) || 5);

          const gap = parseFloat(css.getPropertyValue('--dmc-gap')) || 0;

          const side = parseFloat(css.getPropertyValue('--dmc-side')) || 0;

          const usable = scrollerWidth - 2 * side - gap * (visible - 1);

          // Impossible combinations overflow naturally instead of creating negative cards.

          const cardWidth = Math.max(40, usable / visible);

          const nextWidth = cardWidth + 'px';

          if (this.style.getPropertyValue('--dmc-card-width') !== nextWidth) {

            this.style.setProperty('--dmc-card-width', nextWidth);

          }

        };



        this._updateProgress = () => {

          const fullWidth = this.scroller.scrollWidth;

          const viewportWidth = this.scroller.clientWidth;

          const maxScroll = Math.max(0, fullWidth - viewportWidth);

          const overflowing = maxScroll > 2;

          const nextOverflow = overflowing ? 'true' : 'false';

          if (this.dataset.overflow !== nextOverflow) {

            this.dataset.overflow = nextOverflow;

          }

          if (!overflowing) {

            window.clearTimeout(this._hideTimer);

            this._hideTimer = null;

            this.track.classList.remove('is-visible');

            return;

          }



          const trackWidth = this.track.clientWidth;

          if (!trackWidth || !fullWidth) return;

          const thumbWidth = Math.min(trackWidth, trackWidth * viewportWidth / fullWidth);

          const scrollFraction = Math.max(0, Math.min(1, this.scroller.scrollLeft / maxScroll));

          const targetWidth = thumbWidth + 'px';

          const targetTransform = 'translate3d(' + ((trackWidth - thumbWidth) * scrollFraction) + 'px,0,0)';

          if (this.thumb.style.width !== targetWidth) this.thumb.style.width = targetWidth;

          if (this.thumb.style.transform !== targetTransform) this.thumb.style.transform = targetTransform;

        };



        this._requestUpdate = (withSizing) => {

          if (withSizing) this._pendingSize = true;

          if (this._raf) return;

          this._raf = requestAnimationFrame(() => {

            this._raf = 0;

            if (!this.isConnected) return;

            if (this._pendingSize) {

              this._pendingSize = false;

              this._updateSize();

            }

            this._updateProgress();

            if (this._pendingReveal) {

              this._pendingReveal = false;

              this._showIndicator();

            }

          });

        };



        this._showIndicator = () => {

          if (this.dataset.overflow === 'true') this.track.classList.add('is-visible');

        };

        this._scheduleHide = () => {

          window.clearTimeout(this._hideTimer);

          this._hideTimer = window.setTimeout(() => {

            this._pendingReveal = false;

            if (this.track) this.track.classList.remove('is-visible');

            this._hideTimer = null;

          }, this.hideDelay);

        };

        this._onScroll = () => {

          // Reset on every scroll event, including native momentum after finger release.

          window.clearTimeout(this._hideTimer);

          this._hideTimer = null;

          this._showIndicator();

          this._pendingReveal = true;

          this._scheduleHide();

          this._requestUpdate(false);

        };

        this._onResize = () => this._requestUpdate(true);



        this.scroller.addEventListener('scroll', this._onScroll, { passive: true });

        if ('ResizeObserver' in window) {

          this._resizeObserver = new ResizeObserver(this._onResize);

          this._resizeObserver.observe(this.scroller);

          this._resizeObserver.observe(this.list);

        } else {

          this._usingWindowResize = true;

          window.addEventListener('resize', this._onResize, { passive: true });

        }



        // Initial geometry update stays hidden. Subsequent scroll events may reveal the bar.

        this._updateSize();

        this._updateProgress();

      }



      disconnectedCallback() {

        if (this._initRaf) window.cancelAnimationFrame(this._initRaf);

        this._initRaf = 0;

        if (this._childrenObserver) {

          this._childrenObserver.disconnect();

          this._childrenObserver = null;

        }

        if (this._hideTimer !== null) window.clearTimeout(this._hideTimer);

        this._hideTimer = null;

        if (this._raf) cancelAnimationFrame(this._raf);

        this._raf = 0;

        this._pendingSize = false;

        this._pendingReveal = false;

        if (this.track) this.track.classList.remove('is-visible');

        if (this.scroller && this._onScroll) {

          this.scroller.removeEventListener('scroll', this._onScroll);

        }

        if (this._resizeObserver) {

          this._resizeObserver.disconnect();

          this._resizeObserver = null;

        }

        if (this._usingWindowResize && this._onResize) {

          window.removeEventListener('resize', this._onResize);

        }

        this._usingWindowResize = false;

        this._initialized = false;

      }

    }



    customElements.define('dellumia-circle-nav-v4', DellumiaCircleNav);

  })();


  } catch(e) { console.error(e); }
})();
})();
